module.exports = __webpack_public_path__ + "static/media/animacion2[18].a7df9f39.gif";